export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';

/**
 * action to update user information
 * @param {*} payload 
 */
export function updateUserInfo (payload) {
  return { type: UPDATE_USER_INFO, payload: payload };
}
